import { builder } from '@builder.io/sdk';
import { useEffect, useState } from 'react';

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY || '');
export const useBuilderReference = <T = unknown>(model?: string, id?: string) => {
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!model || !id) {
        return;
      }

      const result = await builder.get(model, {
        options: { includeRefs: true },
        query: { id },
      });

      if (result) {
        setData(result.data as T);
      }
    };

    fetchData();
  }, [model, id]);

  return data;
};
